import { MaskedLines, Reveal, Sparkle } from "./Reveal";

export default function PageHero({ eyebrow, titleLines, copy }) {
  return (
    <section className="relative overflow-hidden pb-16 pt-40 md:pb-24 md:pt-52">
      <Sparkle className="absolute right-8 top-40 hidden h-10 w-10 text-champagne/40 lg:block" />
      <div className="container-x">
        <Reveal>
          <div className="flex items-center gap-4">
            <p className="eyebrow">{eyebrow}</p>
            <span className="h-px w-12 bg-champagne" aria-hidden="true" />
          </div>
        </Reveal>
        <h1 className="mt-6 max-w-4xl font-display text-[clamp(2.6rem,6vw,4.5rem)] font-medium leading-[1.02] text-ink">
          <MaskedLines lines={titleLines} immediate />
        </h1>
        {copy && (
          <Reveal delay={0.35}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-soften md:text-lg">
              {copy}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
